<template>
	<div class="view-list-v">
		<div class="gallery">
			<six-side-img v-for="(item, idx) in dataList" :key="idx"
				:indicatorDirection="`${[1,3,5].includes(idx) ? 'right' : 'left'}`"
				:imgUrl="item.coverImgUrl" :indicatorTxt="item.technicalName" 
				 @click="onClickItem(item.id)" />
		</div>
	</div>
</template>

<script>
	import SixSideImg from '@/components/sixSideImg/index';
	import IndexMixin from './mixins/index.js';
	export default {
		name: 'ListV',
		mixins: [IndexMixin],
		components: {
			SixSideImg
		},
	}
</script>

<style scoped lang="less">
	.view-list-v {
		width: 100%;
		height: calc(1825px * var(--scale-rate));
		
		
		.gallery {
			/* control the size */
			--s: calc(366px * var(--scale-rate));
			/* control the gap */
			--g: calc(10px * var(--scale-rate));
			
			--inc-txt-size: 35px;
			
			position: relative;
			width: 100%;
			height: 100%;
		}
		
		.gallery>.img-container {
			position: absolute;
			left: calc(50% - var(--s) * sqrt(3) / 2 / 2);
			top: calc(50% - var(--s) / 2);
		}
		
		.gallery>.img-container:nth-child(1) {
			--_x: calc(var(--s) * sqrt(3) / 2 / 4 + var(--g) / 2); 
			--_y: calc(-1 * var(--s) * 15 / 8 - var(--g) / 2 * sqrt(3) * 3);
		}
		
		.gallery>.img-container:nth-child(2) {
			--_x: calc(-1 * var(--s) * sqrt(3) / 2 / 4 - var(--g) / 2); 
			--_y: calc(-1 * var(--s) * 9 / 8 - var(--g) / 2 * sqrt(3) * 2);
		}
		
		.gallery>.img-container:nth-child(3) {
			--_x: calc(var(--s) * sqrt(3) / 2 / 4 + var(--g) / 2); 
			--_y: calc(-1 * var(--s) * 3 / 8 - var(--g) / 2 * sqrt(3));
		}
		
		.gallery>.img-container:nth-child(4) {
			--_x: calc(-1 * var(--s) * sqrt(3) / 2 / 4 - var(--g) / 2 / 3); 
			--_y: calc(1 * var(--s) * 3 / 8 + var(--g) / 2 * sqrt(3) / 3);
		}
		
		.gallery>.img-container:nth-child(5) {
			--_x: calc(var(--s) * sqrt(3) / 2 / 4 + var(--g) / 2); 
			--_y: calc(1 * var(--s) * 9 / 8 + var(--g) / 2 * sqrt(3) * 4 / 3);
		}
		
		.gallery>.img-container:nth-child(6) {
			--_x: calc(-1 * var(--s) * sqrt(3) / 2 / 4 - var(--g) / 2); 
			--_y: calc(1 * var(--s) * 15 / 8 + var(--g) / 2 * sqrt(3) * 7 / 3);
		}
		
	}
</style>